module.exports = __webpack_public_path__ + "images/dashboard-progress-db36977c41ee45a60ab5b8fe035eb0bf.png";